/**
 * The setup wizard's five pages and the URLs they live at.
 *
 * Each step is its own address under /dashboard/organization/setup — nested
 * there on purpose: `canAccessPath` matches by prefix, so the wizard inherits
 * the Organization tab's permissions (CompanyAdmin, and a SystemOwner's
 * simulation) without becoming a sidebar item of its own, and stays unreachable
 * for platform staff, who have no organization to set up.
 *
 * The slugs are part of the URL and may be bookmarked or reloaded mid-setup;
 * add to them, don't rename.
 */
export const SETUP_BASE_PATH = "/dashboard/organization/setup";

export const WIZARD_STEPS = [
  { number: 1, slug: "welcome", titleKey: "Dashboard.Setup.steps.welcome" },
  { number: 2, slug: "business", titleKey: "Dashboard.Setup.steps.business" },
  { number: 3, slug: "team", titleKey: "Dashboard.Setup.steps.team" },
  { number: 4, slug: "services", titleKey: "Dashboard.Setup.steps.services" },
  { number: 5, slug: "page", titleKey: "Dashboard.Setup.steps.page" },
];

export const TOTAL_STEPS = WIZARD_STEPS.length;

/** The step number a URL segment names, or null for a missing or unknown one. */
export const stepFromSlug = (slug) =>
  WIZARD_STEPS.find((step) => step.slug === slug)?.number ?? null;

/** The address of step `number`, clamped into range. */
export const setupPath = (number) => {
  const clamped = Math.min(Math.max(Number(number) || 1, 1), TOTAL_STEPS);
  return `${SETUP_BASE_PATH}/${WIZARD_STEPS[clamped - 1].slug}`;
};
